/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FaAlignJustify } from 'react-icons/fa';

const SorttableElement = ({ question, questionNum }) => (
  <Droppable droppableId={`droppable-${questionNum}`} type="PRODUCTS">
    {(provided, snapshot) => (
      <DroppableElement
        ref={provided.innerRef}
        isDragging={snapshot.isDraggingOver}
      >
        {question.Products.map((product, index) => (
          <Draggable
            key={`${questionNum}${index}`}
            draggableId={`${questionNum}${index}`}
            index={index}
          >
            {(provided, snapshot) => (
              <Element
                ref={provided.innerRef}
                {...provided.draggableProps}
                isDragging={snapshot.isDragging}
                isProd
                style={provided.draggableProps.style}
              >
                <Content>
                  <span {...provided.dragHandleProps}>
                    <FaAlignJustify />
                  </span>
                  <ProductText>{product.displayName}</ProductText>
                </Content>
              </Element>
            )}
          </Draggable>
        ))}
        {provided.placeholder}
      </DroppableElement>
    )}
  </Droppable>
);

const DroppableElement = styled.div`
  background: ${(props) => (props.isDragging ? 'lightblue' : 'lightgray')};
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  height: 700px;
  border-bottom: 0.5px solid rgba(0,0,0,0.3);
  overflow: hidden;
  overflow-y: auto;
  margin: 0;
`;

const Element = styled.div`
  list-style-type: none;
  background: ${(props) => (props.isDragging ? 'green' : 'white')};
  color: ${(props) => (props.isDragging ? '#fff' : '#333')} !important;
  border: 1px solid rgba(0, 0, 0, 0.3);
  width: 100%;
  margin: 0!important;
  padding: 6px;
  height: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  text-align: center;
`;

const Content = styled.p`
  display: flex;
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
`;

const ProductText = styled.p`
  width: 100%;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  margin: 0 !important;
  padding: 0 !important;
`;

SorttableElement.defaultProps = {
  question: {
    Products: [],
  },
};

SorttableElement.propTypes = {
  question: PropTypes.shape({
    Products: PropTypes.arrayOf(PropTypes.shape({
      displayName: PropTypes.string.isRequired,
    })).isRequired,
  }),
  questionNum: PropTypes.number.isRequired,
};

export default SorttableElement;
